import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Invoices_ds_get_billing_contract_line_by_billingContractLineIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { billingContractLineId: number }): 
  Promise<{ result: { Id?: number, LineNumber?: number, BillingRates?: { Id?: number }[], BillingTasks?: { Id?: number }[], Details?: { BillingContractLineId?: number, StrategyFieldName?: string }[], BillingContract?: { Id?: number, StatusId?: number } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.billingContractLineId)) {
      missingRequiredInParams.push('\'billingContractLineId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Invoices/datasources/ds_get_billing_contract_line_by_billingContractLineId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

